// extracted by mini-css-extract-plugin
export default {"paper":"styles_paper__dIDj3"};